import { cartMobx, discountMobx } from 'mobx/mall'
import { orderMobx } from 'restaurant'
import { advertMobx, checkoutMobx, memberMobx } from '@mobxStore'
import { loadingLayer, toastLayer } from '@utils'
import { MallCheckoutPayController, MallRestoreOrderController } from '@ctrls/mallController'
import CashierController from '@ctrls/cashierController'
import payPlanMobx from '@mobx/mall/payment/payPlan.mobx'
import { cloneDeep } from '@dt/fe-utils/dist/lodash'

interface ISaveOrderProps {
  isRepeat?: boolean;
  handlePayAction?: () => void;
  handleSaveError?: () => void;
}

interface IPayOrderProps extends ISaveOrderProps {
  history: any;
}

let isPayOrdering = false

const toPay = async (ordersId: string) => {
  // TODO: startPay可以合并到下单
  payPlanMobx.updateOrder({ uniqueKey: ordersId })
  const prepayCreate = await orderMobx.startPay(ordersId)
  return await MallCheckoutPayController.doPay(prepayCreate)
}

export const saveOrder = async (params: ISaveOrderProps = {}) => {
  const { isRepeat, handlePayAction, handleSaveError } = params || {}
  const isCanOrder = cartMobx.cartResult.totalCnt && cartMobx.cartResult.isCanSave

  // 当前不可下单的状态
  if (!isCanOrder) {
    return false
  }

  // loading
  loadingLayer.show()

  // 处理用户的case(当游客勾选了需要保存信息才创建虚拟用户)
  if (!Config.token && checkoutMobx.isSaveOrderInfo) {
    try {
      const memberId = await memberMobx.virtualMember({
        nickName: checkoutMobx.contactInfo.contactName || checkoutMobx.contactInfo.contactMobile,
      })
      if (memberId) {
        discountMobx.setVirtualMemberId(memberId)
      }
    } catch (err) {
      console.error(err)
    }
  }

  // 关闭等待支付的订单
  if (cartMobx.ordersId && orderMobx?.order?.status === 'Paying') {
    try {
      await MallCheckoutPayController.resume(cartMobx.ordersId)
    } catch (e) {
      loadingLayer.hide()
      if (e.message) {
        toastLayer.error({
          content: e.message,
          duration: 1000,
        })
      }
      return
    }
  }

  // save order
  return cartMobx.save().then(async (res: any) => {
    try {
      advertMobx.traceCartProductsFromAdvert(res)
    } catch (error) {
      console.log(error)
    }
    loadingLayer.hide()
    const selectCouponIds = cloneDeep(discountMobx.discountAction.selectCouponIds)
    const selectItemCouponIds = cloneDeep(discountMobx.discountAction.selectItemCouponIds)
    discountMobx.setSelectCoupon(selectCouponIds, selectItemCouponIds)
    // if (!isRepeat) {
    //   handlePayAction()
    // }
    return true
  }).catch(async (err: any) => {
    console.error(err, 'err')
    loadingLayer.hide()
    if (err.code === -118 || err.code === -395 || err.code === -165 || err.code === -161 || err.code === -166 || err.code === -167) {
      // 处理订单未同步的case
      if (!isRepeat) {
        if (cartMobx.ordersId) {
          await orderMobx.init(cartMobx.ordersId)
        }
        // 实际购物车需要计算的餐品发生变化 需要重新主动算一次
        discountMobx.calcCart()
        await saveOrder({
          isRepeat: true,
          handlePayAction,
          handleSaveError,
        })
      } else {
        // 下单异常
        handleSaveError && handleSaveError()
      }
    } else {
      await CashierController.handleSaveError(err, 'checkout')
    }
    return false
  })
}

export const payOrder = async ({
  history,
  handlePayAction,
  handleSaveError
}: IPayOrderProps) => {
  // 无订单先下单
  if (!cartMobx.ordersId) {
    const flag = await saveOrder({
      handlePayAction,
      handleSaveError
    })
    if (!flag) {
      return
    }
  }

  // paying
  if (isPayOrdering) {
    return
  } else {
    isPayOrdering = true
  }

  // 支付准备
  try {
    await cartMobx.syncMkt()
    await MallCheckoutPayController.preparePay()
  } catch (e) {
    if (e.doc_url) {
      // 这个是stripe报的错。要等apple弹窗关闭后展示。
      setTimeout(() => {
        toastLayer.error({
          content: e.message,
          duration: 1000,
        })
      }, 2000)
    } else if (e.message) {
      toastLayer.error({
        content: e.message,
        duration: 1000,
      })
    }
    isPayOrdering = false
    return
  }

  // loading
  loadingLayer.show()

  // 处理用户的case
  // 当游客勾选了需要保存信息才创建虚拟用户
  // if (!Config.token && checkoutMobx.isSaveOrderInfo) {
  //   try {
  //     const memberId = await memberMobx.virtualMember({
  //       nickName: checkoutMobx.contactInfo.contactName || checkoutMobx.contactInfo.contactMobile,
  //     })
  //     if (memberId) {
  //       discountMobx.setVirtualMemberId(memberId)
  //     }
  //     // 限行置入营销结果，解决营销计算结果异步的问题
  //   } catch (err) {
  //     console.error(err)
  //   }
  // }

  const _ordersId = cartMobx.ordersId

  MallRestoreOrderController.hold(_ordersId)

  try {
    const result = await toPay(_ordersId)
    if (result === 'async') {
      isPayOrdering = false
      loadingLayer.hide()
      return
    }
    isPayOrdering = false
    loadingLayer.hide()
  } catch (e) {
    // TODO 细粒度控制生成新订单
    // 下单失败则清除购物车中的订单Id
    cartMobx.saveResetCart()
    cartMobx.clearOrdersId()
    isPayOrdering = false
    loadingLayer.hide()
    history.replace({
      pathname: '/mpayfail',
      state: {
        reason: e.message,
        type: 'mall'
      }
    })
    return
  }
  MallRestoreOrderController.clearHold()
  // 先付费下单成功清理当前购物车的缓存,订单的缓存
  cartMobx.reset(cartMobx.info.eatType)
  // discountMobx.clearDiscountAction()
  memberMobx.refreshMemeberBenefits()
  // 支付成功后，重置时间
  // timePickMobx.reset()
  setTimeout(() => {
    history.replace(`/result/${_ordersId}`)
  }, 200)
}
